import React, { useEffect, useState } from "react";
import SoftBadge from "modules/common/SoftBadge";
import CallResponse from "./CallResponse";
import { useTicketHistory } from "../actionables/store";
import Comments from "./Comments";
import { Button, CloseButton, Offcanvas } from "react-bootstrap";
import { buttonStyle, formRow, selected } from "./commonFunction";
import SaveFeedBack from "./SaveFeedBack";
import Tick from "assets/svgs/tick";
import MedicalSlotDisposition from "./MedicalSlotDisposition";
import moment from "moment";
import { Descriptions } from 'antd';
import _ from 'lodash';
import { CATEGORY, TICKET_STATUS } from 'modules/my_tickets/data';
import { DispositionComponent } from "../../lead_Detail_pop_up/DispositionComponent";
import { DISP_FLAG } from "../../utilities/utility";

function SlotBookingMedical({ week, data, customerId, bookingId, id, setData, setBooking, setActiveOrder, customer }) {
  const { fetchTicketHistory, ticketData } = useTicketHistory();
  const [show, setShow] = useState(false);
  const [selectSlot, setSelectSlot] = useState(null);
  const [isValid, setIsValid] = useState(true);
  const [formData, setFormData] = useState({ callResponse: null, comments: null, });
  
  useEffect(() => {
    if (data?.unanswered_count !== 0) {
      const current = moment();
      const lastUpdated = moment(data?.updatedAt).utcOffset("+05:30");
      if (current.diff(lastUpdated, 'minutes') <= 5) { setIsValid(false); }
    } else { setIsValid(true); }
  }, [id, data]);  
  
  useEffect(() => {
    if (customerId) { fetchTicketHistory(customerId); }
  }, [customerId]);
  
  const renderedComponents = [{ name: "callResponse", value: formData.callResponse }];
  const medicalEscalationTickets = ticketData?.filter(ticket => ticket.category === CATEGORY.MEDICAL_ESCALATIONS &&([TICKET_STATUS.OPEN,  TICKET_STATUS.PENDING].includes(ticket.status))).reverse();
  const hasTicketData = medicalEscalationTickets?.length > 0;
  const ticket = hasTicketData ? medicalEscalationTickets[0] : null;
  const category = _.get(ticket, 'category', "");
  const subcategory = _.get(ticket, 'sub_category', "");
  
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setSelectSlot(null);
  };

  return (
    <>
      <Button className="flex-1" onClick={() => handleShow("lg-down")}>
        <Tick />
      </Button>
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: DISP_FLAG ?"77%":"40%" }}
        onHide={handleClose}
      >
        <Offcanvas.Header CloseButton>
          <Offcanvas.Title>Add Feedback</Offcanvas.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleClose}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ maxHeight: "85vh", overflowY: "scroll" }}
          className="scrollable-container"
        >
        <div className="d-flex flex-row gap-3">
            <div>
            {DISP_FLAG &&<DispositionComponent customer={customer} />}
            </div>
          <div>
            {data?.tag === "SLOT_BOOKING_MEDICAL" ? (
              <Descriptions title="User Info" bordered layout='vertical'>
                <Descriptions.Item span={2} label="Category" className='text-capitalize'>{category.replaceAll("_", " ")}</Descriptions.Item>
                <Descriptions.Item span={2} label="Sub Category" className='text-capitalize'> {subcategory.replaceAll("_", " ")}</Descriptions.Item>
                <Descriptions.Item span={3} label="Comments">{ticket?.comments?.[0]?.description}</Descriptions.Item>
              </Descriptions>
            ) : null}
            <CallResponse
              formData={formData}
              buttonStyle={buttonStyle}
              selected={selected}
              setFormData={setFormData}
              formRow={formRow}
              isValid={isValid}
              bookingId={bookingId}
            />
            {formData?.callResponse == "answered" ? (
              <div>
                {selectSlot ? (
                  <div className="fw-bold d-flex flex-row fs-1 my-2 card p-2">
                    <span>Slot booked at :</span>
                    <SoftBadge pill bg="info" className="me-2 ms-2">
                      <span style={{ fontSize: "12px" }} className="text-wrap text-break">
                        {selectSlot?.slotTime ? moment(selectSlot?.slotTime).utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss") : selectSlot}
                      </span>
                    </SoftBadge>
                  </div>
                ) : (
                  <MedicalSlotDisposition
                    caseDetails={data}
                    comment={formData.comments}
                    setFormData={setFormData}
                    customerData={data}
                    show={show}
                    setSelectSlot={setSelectSlot}
                  />
                )}
                <Comments
                  setFormData={setFormData}
                  length={formData?.comments?.length}
                />
              </div>
            ) : null}
            {formData.callResponse === "answered" &&
              formData.comments &&
              formData.comments.length > 5 && (
                <SaveFeedBack
                  setShow={setShow}
                  bookingId={bookingId}
                  week={week}
                  formData={formData}
                  selected={selected}
                  buttonStyle={buttonStyle}
                  formRow={formRow}
                  renderedComponents={renderedComponents}
                  id={id}
                  customerId={customerId}
                  setData={setData}
                  setBooking={setBooking}
                  setActiveOrder={setActiveOrder}
                />
              )}
            {["unanswered", "languageIssue"].includes(formData?.callResponse) && (
              <SaveFeedBack
                setShow={setShow}
                bookingId={bookingId}
                week={week}
                formData={formData}
                selected={selected}
                buttonStyle={buttonStyle}
                formRow={formRow}
                renderedComponents={renderedComponents}
                id={id}
                customerId={customerId}
                setData={setData}
                setBooking={setBooking}
                setActiveOrder={setActiveOrder}
                disabled={!isValid}
              />
            )}
          </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SlotBookingMedical;
